module.exports = __webpack_public_path__ + "static/img/searchlogo.2739cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/searchlogo.png
// module id = x1fX
// module chunks = 1